/**
 * @generated SignedSource<<6951df79f943fd3e3e5ac9f7483db2c6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InstantBuyStatus = "CLOSED" | "OPEN" | "PURCHASED" | "%future added value";
export type instantBuyCheckoutQuery$variables = {
  checkoutId: string;
};
export type instantBuyCheckoutQuery$data = {
  readonly instantBuy: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly name: string;
      };
    };
    readonly id: string;
    readonly lineItems: ReadonlyArray<{
      readonly id: string;
      readonly productInstance: {
        readonly id: string;
        readonly reservation: {
          readonly id: string;
          readonly space: {
            readonly frame: string;
            readonly id: string;
          };
        };
        readonly retrievedWithId: string | null | undefined;
      };
    }>;
    readonly status: InstantBuyStatus;
  };
};
export type instantBuyCheckoutQuery = {
  response: instantBuyCheckoutQuery$data;
  variables: instantBuyCheckoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "checkoutId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "clientReferenceId",
        "variableName": "checkoutId"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "LineItem",
  "kind": "LinkedField",
  "name": "lineItems",
  "plural": true,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInstance",
      "kind": "LinkedField",
      "name": "productInstance",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VendingReservation",
          "kind": "LinkedField",
          "name": "reservation",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Space",
              "kind": "LinkedField",
              "name": "space",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "frame",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "retrievedWithId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "instantBuyCheckoutQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "InstantBuy",
          "kind": "LinkedField",
          "name": "instantBuy",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Hub",
              "kind": "LinkedField",
              "name": "hub",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "kind": "RequiredField",
                  "field": (v4/*:: as any*/),
                  "action": "THROW"
                }
              ],
              "storageKey": null
            },
            {
              "kind": "RequiredField",
              "field": (v5/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "instantBuyCheckoutQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "InstantBuy",
        "kind": "LinkedField",
        "name": "instantBuy",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "50e68703996035601fd11d346e6ef1f0",
    "id": null,
    "metadata": {},
    "name": "instantBuyCheckoutQuery",
    "operationKind": "query",
    "text": "query instantBuyCheckoutQuery(\n  $checkoutId: String!\n) {\n  instantBuy(by: {clientReferenceId: $checkoutId}) {\n    id\n    status\n    hub {\n      id\n      meta {\n        id\n        name\n      }\n    }\n    lineItems {\n      id\n      productInstance {\n        id\n        reservation {\n          id\n          space {\n            id\n            frame\n          }\n        }\n        retrievedWithId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a322d40f60a4942f8e0855d6f9d603c";

export default node;
